import { Navigate, Outlet } from 'react-router-dom'

import { useUserStore } from '../../entities/user/stores/user.store'

const PublicRoute = () => {
  const user = useUserStore((state) => state.user)
  const isAuthenticated = Boolean(user?.token)
  if (isAuthenticated) {
    return (
      <Navigate
        to="/"
        replace
      />
    )
  }

  return <Outlet />
}

export default PublicRoute
